export const translations = {
  en: {
    // Header
    header: {
      services: "Services",
      fleet: "Fleet",
      about: "About",
      bookNow: "Book Now",
    },
    
    // Hero
    hero: {
      title: "Experience",
      titleHighlight: "Premium Transportation",
      subtitle: "Arrive in style with our executive chauffeur service. Professional, punctual, and luxurious.",
      reserveRide: "Reserve Your Ride",
      viewFleet: "View Fleet",
    },
    
    // Services
    services: {
      title: "Our Services",
      subtitle: "Luxury transportation for every occasion",
      transfer: {
        title: "Premium Transport Service",
        description: "Professional point-to-point chauffeur with luxury vehicles",
      },
      corporate: {
        title: "Corporate Events",
        description: "Professional service for meetings, conferences and corporate events.",
      },
      hourly: {
        title: "Hourly Booking",
        description: "Flexible hourly service for shopping, tours or multiple destinations (min. 3h).",
      },
      pricing: {
        title: "Transparent Pricing",
        basePrice: "Base price",
        perKm: "Per kilometer",
        perMinute: "Per minute",
      },
      included: {
        title: "Included Services",
        driver: "Professional chauffeur",
        vehicles: "Premium vehicles",
        service247: "24/7 Service",
        wifi: "Onboard WiFi",
      },
      example: {
        label: "Example",
        route: "Brussels Center → Airport",
        calculation: "Calculation",
      },
    },
    
    // Fleet
    fleet: {
      title: "Our Premium Fleet",
      subtitle: "Impeccably maintained vehicles",
      onRequest: "On request",
      passengers: "Passengers",
      features: "Premium Features",
      vehicleFeatures: {
        hybrid: "Hybrid",
        climateControl: "Climate control",
        comfortableSeats: "Comfortable seats",
        wifi: "WiFi",
        premiumSound: "Premium sound",
        extraSpace: "Extra space",
      },
      categories: {
        executiveSedan: "Executive Sedan",
        luxurySedan: "Luxury Sedan",
        businessSedan: "Business Sedan",
        luxuryEstate: "Luxury Estate",
      },
      badges: {
        recommended: "Recommended",
        premium: "Premium",
        elegance: "Elegance",
        maxLuggage: "Max Luggage",
      },
      luggage: {
        standard: "2 large + 2 small bags",
        extended: "2 large + 2 small bags",
      },
    },
    
    // Why Us
    whyUs: {
      title: "Why Choose Us",
      subtitle: "Excellence in every detail",
      licensed: {
        title: "Fully Licensed & Insured",
        description: "Your safety is our priority with comprehensive coverage",
      },
      chauffeurs: {
        title: "Professional Chauffeurs",
        description: "Experienced, courteous drivers dedicated to your comfort",
      },
      fleet: {
        title: "Premium Fleet",
        description: "Immaculate vehicles maintained to the highest standards",
      },
    },
    
    // About Us
    about: {
      title: "About Us",
      subtitle: "Your trusted partner for luxury transportation",
      experience: {
        title: "Years of Excellence",
        description: "With over 10 years of experience in premium chauffeur services, we have established ourselves as the reference in luxury transportation in Belgium. Our expertise allows us to anticipate your needs and provide impeccable service on every journey.",
      },
      commitment: {
        title: "Our Commitment",
        description: "We are committed to providing exceptional service that exceeds your expectations. Every detail is carefully considered, from vehicle selection to route planning, to ensure your complete satisfaction.",
      },
      values: {
        title: "Our Values",
        description: "Professionalism, punctuality, discretion, and excellence are at the heart of everything we do. We treat each client with respect and attention, ensuring a personalized experience tailored to your specific needs.",
      },
      team: {
        title: "Our Team",
        description: "Our experienced and multilingual chauffeurs are carefully selected and regularly trained. They know the region perfectly and are dedicated to making each journey pleasant, safe, and comfortable.",
      },
    },
    
    // Booking
    booking: {
      title: "Book Your Luxury Ride",
      subtitle: "Premium point-to-point transport service",
      detailsTitle: "Booking Details",
      detailsSubtitle: "Fill in your information for an instant quote",
      yourInfo: "Your Information",
      fullName: "Full Name",
      fullNamePlaceholder: "John Doe",
      email: "Email",
      emailPlaceholder: "john@example.com",
      phone: "Phone",
      phonePlaceholder: "+32 470 12 34 56",
      serviceType: "Service Type",
      serviceTypePlaceholder: "Choose a service",
      serviceDescriptions: {
        transfer: "Point-to-point with distance + time calculation",
        corporate: "Corporate events - billed by the hour",
        hourly: "Flexible service - minimum 3 hours",
      },
      vehicle: "Vehicle",
      vehiclePlaceholder: "Select a vehicle",
      date: "Date",
      datePlaceholder: "Select a date",
      time: "Time",
      timePlaceholder: "HH:MM",
      pickup: "Pickup Location",
      pickupPlaceholder: "Enter pickup address",
      dropoff: "Drop-off Location",
      dropoffPlaceholder: "Enter drop-off address",
      hours: "Number of Hours",
      hoursPlaceholder: "Minimum 3 hours",
      calculating: "Calculating...",
      calculate: "Calculate Price",
      estimatedPrice: "Estimated Price",
      distance: "Distance",
      duration: "Duration",
      confirmBooking: "Confirm Booking",
      processing: "Processing...",
      errors: {
        fillRequired: "Please fill in all required fields",
        enterAddresses: "Please enter addresses and distance/duration",
        enterAddressHours: "Please enter address and number of hours",
        calculationError: "Error calculating price. Please try again.",
      },
      success: {
        title: "Booking Confirmed! Reference: {reference}",
        emailSent: "A confirmation email has been sent to {email}",
      },
    },
    
    // Footer
    footer: {
      services: "Services",
      company: "Company",
      about: "About Us",
      fleet: "Fleet",
      tagline: "Premium chauffeur service for discerning clients",
      quickLinks: "Quick Links",
      contact: "Contact",
      available247: "Available 24/7",
      copyright: "© 2025 Luxury Transfer Service. All rights reserved.",
    },
  },
  
  fr: {
    header: {
      services: "Services",
      fleet: "Flotte",
      about: "À Propos",
      bookNow: "Réserver",
    },
    hero: {
      title: "Vivez",
      titleHighlight: "Un Transport Premium",
      subtitle: "Arrivez avec style grâce à notre service de chauffeur executive. Professionnel, ponctuel et luxueux.",
      reserveRide: "Réservez Maintenant",
      viewFleet: "Voir la Flotte",
    },
    services: {
      title: "Nos Services",
      subtitle: "Transport de luxe pour chaque occasion",
      transfer: {
        title: "Service de Transport Premium",
        description: "Chauffeur professionnel de point à point avec véhicules de luxe",
      },
      corporate: {
        title: "Événements d'Entreprise",
        description: "Service professionnel pour réunions, conférences et événements corporate.",
      },
      hourly: {
        title: "Réservation par Heure",
        description: "Service flexible à l'heure pour shopping, visites ou destinations multiples (min. 3h).",
      },
      pricing: {
        title: "Tarification Transparente",
        basePrice: "Prix de base",
        perKm: "Par kilomètre",
        perMinute: "Par minute",
      },
      included: {
        title: "Services Inclus",
        driver: "Chauffeur professionnel",
        vehicles: "Véhicules premium",
        service247: "Service 24/7",
        wifi: "WiFi à bord",
      },
      example: {
        label: "Exemple",
        route: "Bruxelles Centre → Aéroport",
        calculation: "Calcul",
      },
    },
    fleet: {
      title: "Notre Flotte Premium",
      subtitle: "Véhicules impeccables",
      onRequest: "Sur demande",
      passengers: "Passagers",
      features: "Équipements Premium",
      vehicleFeatures: {
        hybrid: "Hybride",
        climateControl: "Climatisation",
        comfortableSeats: "Sièges confortables",
        wifi: "WiFi",
        premiumSound: "Son premium",
        extraSpace: "Espace supplémentaire",
      },
      categories: {
        executiveSedan: "Berline Executive",
        luxurySedan: "Berline de Luxe",
        businessSedan: "Berline Business",
        luxuryEstate: "Break de Luxe",
      },
      badges: {
        recommended: "Recommandé",
        premium: "Premium",
        elegance: "Élégance",
        maxLuggage: "Max Bagages",
      },
      luggage: {
        standard: "2 grands + 2 petits bagages",
        extended: "2 grands + 2 petits bagages",
      },
    },
    whyUs: {
      title: "Pourquoi Nous Choisir",
      subtitle: "Excellence dans chaque détail",
      licensed: {
        title: "Agréé et Assuré",
        description: "Votre sécurité est notre priorité avec une couverture complète",
      },
      chauffeurs: {
        title: "Chauffeurs Professionnels",
        description: "Conducteurs expérimentés et courtois dédiés à votre confort",
      },
      fleet: {
        title: "Flotte Premium",
        description: "Véhicules impeccables maintenus aux normes les plus élevées",
      },
    },
    
    about: {
      title: "À Propos de Nous",
      subtitle: "Votre partenaire de confiance pour le transport de luxe",
      experience: {
        title: "Des Années d'Excellence",
        description: "Avec plus de 10 ans d'expérience dans les services de chauffeur premium, nous nous sommes imposés comme la référence en matière de transport de luxe en Belgique. Notre expertise nous permet d'anticiper vos besoins et de fournir un service irréprochable à chaque trajet.",
      },
      commitment: {
        title: "Notre Engagement",
        description: "Nous nous engageons à fournir un service exceptionnel qui dépasse vos attentes. Chaque détail est soigneusement considéré, de la sélection du véhicule à la planification de l'itinéraire, pour garantir votre satisfaction complète.",
      },
      values: {
        title: "Nos Valeurs",
        description: "Professionnalisme, ponctualité, discrétion et excellence sont au cœur de tout ce que nous faisons. Nous traitons chaque client avec respect et attention, assurant une expérience personnalisée adaptée à vos besoins spécifiques.",
      },
      team: {
        title: "Notre Équipe",
        description: "Nos chauffeurs expérimentés et multilingues sont soigneusement sélectionnés et régulièrement formés. Ils connaissent parfaitement la région et sont dévoués à rendre chaque voyage agréable, sûr et confortable.",
      },
    },
    booking: {
      title: "Réservez Votre Course de Luxe",
      subtitle: "Service de transport premium de point à point",
      detailsTitle: "Détails de la Réservation",
      detailsSubtitle: "Remplissez vos informations pour un devis instantané",
      yourInfo: "Vos Informations",
      fullName: "Nom Complet",
      fullNamePlaceholder: "Jean Dupont",
      email: "Email",
      emailPlaceholder: "jean@example.com",
      phone: "Téléphone",
      phonePlaceholder: "+32 470 12 34 56",
      serviceType: "Type de Service",
      serviceTypePlaceholder: "Choisissez un service",
      serviceDescriptions: {
        transfer: "Point à point avec calcul distance + temps",
        corporate: "Événements d'entreprise - facturation à l'heure",
        hourly: "Service flexible - minimum 3 heures",
      },
      vehicle: "Véhicule",
      vehiclePlaceholder: "Sélectionnez un véhicule",
      date: "Date",
      datePlaceholder: "Sélectionnez une date",
      time: "Heure",
      timePlaceholder: "HH:MM",
      pickup: "Point de Départ",
      pickupPlaceholder: "Entrez l'adresse de départ",
      dropoff: "Point d'Arrivée",
      dropoffPlaceholder: "Entrez l'adresse d'arrivée",
      hours: "Nombre d'Heures",
      hoursPlaceholder: "Minimum 3 heures",
      calculating: "Calcul en cours...",
      calculate: "Calculer le Prix",
      estimatedPrice: "Prix Estimé",
      distance: "Distance",
      duration: "Durée",
      confirmBooking: "Confirmer la Réservation",
      processing: "Traitement...",
      errors: {
        fillRequired: "Veuillez remplir tous les champs obligatoires",
        enterAddresses: "Veuillez entrer les adresses et la distance/durée",
        enterAddressHours: "Veuillez entrer l'adresse et le nombre d'heures",
        calculationError: "Erreur de calcul du prix. Veuillez réessayer.",
      },
      success: {
        title: "Réservation Confirmée! Référence: {reference}",
        emailSent: "Un email de confirmation a été envoyé à {email}",
      },
    },
    footer: {
      services: "Services",
      company: "Entreprise",
      about: "À Propos",
      fleet: "Flotte",
      tagline: "Service de chauffeur premium pour clients exigeants",
      quickLinks: "Liens Rapides",
      contact: "Contact",
      available247: "Disponible 24/7",
      copyright: "© 2025 Luxury Transfer Service. Tous droits réservés.",
    },
  },
  
  nl: {
    header: {
      services: "Diensten",
      fleet: "Vloot",
      about: "Over Ons",
      bookNow: "Boeken",
    },
    hero: {
      title: "Ervaar",
      titleHighlight: "Premium Transport",
      subtitle: "Arriveer in stijl met onze executive chauffeursdienst. Professioneel, punctueel en luxueus.",
      reserveRide: "Reserveer Nu",
      viewFleet: "Bekijk Vloot",
    },
    services: {
      title: "Onze Diensten",
      subtitle: "Luxe vervoer voor elke gelegenheid",
      transfer: {
        title: "Premium Vervoersservice",
        description: "Professionele chauffeur van punt tot punt met luxe voertuigen",
      },
      corporate: {
        title: "Zakelijke Evenementen",
        description: "Professionele service voor vergaderingen, conferenties en zakelijke evenementen.",
      },
      hourly: {
        title: "Per Uur Boeken",
        description: "Flexibele service per uur voor winkelen, tours of meerdere bestemmingen (min. 3u).",
      },
      pricing: {
        title: "Transparante Prijzen",
        basePrice: "Basisprijs",
        perKm: "Per kilometer",
        perMinute: "Per minuut",
      },
      included: {
        title: "Inbegrepen Services",
        driver: "Professionele chauffeur",
        vehicles: "Premium voertuigen",
        service247: "24/7 Service",
        wifi: "WiFi aan boord",
      },
      example: {
        label: "Voorbeeld",
        route: "Brussel Centrum → Luchthaven",
        calculation: "Berekening",
      },
    },
    fleet: {
      title: "Onze Premium Vloot",
      subtitle: "Onberispelijk onderhouden voertuigen",
      onRequest: "Op aanvraag",
      passengers: "Passagiers",
      features: "Premium Kenmerken",
      vehicleFeatures: {
        hybrid: "Hybride",
        climateControl: "Klimaatregeling",
        comfortableSeats: "Comfortabele stoelen",
        wifi: "WiFi",
        premiumSound: "Premium geluid",
        extraSpace: "Extra ruimte",
      },
      categories: {
        executiveSedan: "Executive Sedan",
        luxurySedan: "Luxe Sedan",
        businessSedan: "Business Sedan",
        luxuryEstate: "Luxe Stationwagen",
      },
      badges: {
        recommended: "Aanbevolen",
        premium: "Premium",
        elegance: "Elegantie",
        maxLuggage: "Max Bagage",
      },
      luggage: {
        standard: "2 grote + 2 kleine koffers",
        extended: "2 grote + 2 kleine koffers",
      },
    },
    whyUs: {
      title: "Waarom Kiezen Voor Ons",
      subtitle: "Excellentie in elk detail",
      licensed: {
        title: "Volledig Gelicentieerd & Verzekerd",
        description: "Uw veiligheid is onze prioriteit met uitgebreide dekking",
      },
      chauffeurs: {
        title: "Professionele Chauffeurs",
        description: "Ervaren, hoffelijke chauffeurs toegewijd aan uw comfort",
      },
      fleet: {
        title: "Premium Vloot",
        description: "Onberispelijke voertuigen onderhouden volgens de hoogste normen",
      },
    },
    
    about: {
      title: "Over Ons",
      subtitle: "Uw vertrouwde partner voor luxe vervoer",
      experience: {
        title: "Jaren van Uitmuntendheid",
        description: "Met meer dan 10 jaar ervaring in premium chauffeursdiensten hebben we onszelf gevestigd als de referentie in luxe vervoer in België. Onze expertise stelt ons in staat om uw behoeften te anticiperen en onberispelijke service te bieden bij elke reis.",
      },
      commitment: {
        title: "Onze Toewijding",
        description: "We zijn toegewijd aan het leveren van uitzonderlijke service die uw verwachtingen overtreft. Elk detail wordt zorgvuldig overwogen, van voertuigselectie tot routeplanning, om uw volledige tevredenheid te garanderen.",
      },
      values: {
        title: "Onze Waarden",
        description: "Professionaliteit, punctualiteit, discretie en excellentie staan centraal in alles wat we doen. We behandelen elke klant met respect en aandacht, en zorgen voor een gepersonaliseerde ervaring afgestemd op uw specifieke behoeften.",
      },
      team: {
        title: "Ons Team",
        description: "Onze ervaren en meertalige chauffeurs worden zorgvuldig geselecteerd en regelmatig getraind. Ze kennen de regio perfect en zijn toegewijd aan het aangenaam, veilig en comfortabel maken van elke reis.",
      },
    },
    booking: {
      title: "Boek Uw Luxe Rit",
      subtitle: "Premium punt-tot-punt vervoersservice",
      detailsTitle: "Boekingsdetails",
      detailsSubtitle: "Vul uw gegevens in voor een directe offerte",
      yourInfo: "Uw Informatie",
      fullName: "Volledige Naam",
      fullNamePlaceholder: "Jan Jansen",
      email: "E-mail",
      emailPlaceholder: "jan@example.com",
      phone: "Telefoon",
      phonePlaceholder: "+32 470 12 34 56",
      serviceType: "Service Type",
      serviceTypePlaceholder: "Kies een service",
      serviceDescriptions: {
        transfer: "Punt-tot-punt met afstand + tijd berekening",
        corporate: "Zakelijke evenementen - gefactureerd per uur",
        hourly: "Flexibele service - minimum 3 uur",
      },
      vehicle: "Voertuig",
      vehiclePlaceholder: "Selecteer een voertuig",
      date: "Datum",
      datePlaceholder: "Selecteer een datum",
      time: "Tijd",
      timePlaceholder: "UU:MM",
      pickup: "Ophaallocatie",
      pickupPlaceholder: "Voer ophaladres in",
      dropoff: "Afleverlocatie",
      dropoffPlaceholder: "Voer afleveradres in",
      hours: "Aantal Uren",
      hoursPlaceholder: "Minimum 3 uur",
      calculating: "Berekenen...",
      calculate: "Prijs Berekenen",
      estimatedPrice: "Geschatte Prijs",
      distance: "Afstand",
      duration: "Duur",
      confirmBooking: "Boeking Bevestigen",
      processing: "Verwerken...",
      errors: {
        fillRequired: "Vul alle verplichte velden in",
        enterAddresses: "Voer adressen en afstand/duur in",
        enterAddressHours: "Voer adres en aantal uren in",
        calculationError: "Fout bij het berekenen van de prijs. Probeer het opnieuw.",
      },
      success: {
        title: "Boeking Bevestigd! Referentie: {reference}",
        emailSent: "Een bevestigingsmail is verzonden naar {email}",
      },
    },
    footer: {
      services: "Diensten",
      company: "Bedrijf",
      about: "Over Ons",
      fleet: "Vloot",
      tagline: "Premium chauffeursdienst voor veeleisende klanten",
      quickLinks: "Snelle Links",
      contact: "Contact",
      available247: "24/7 Beschikbaar",
      copyright: "© 2025 Luxury Transfer Service. Alle rechten voorbehouden.",
    },
  },
  
  de: {
    header: {
      services: "Dienstleistungen",
      fleet: "Flotte",
      about: "Über Uns",
      bookNow: "Buchen",
    },
    hero: {
      title: "Erleben Sie",
      titleHighlight: "Premium Transport",
      subtitle: "Kommen Sie stilvoll an mit unserem Executive-Chauffeurservice. Professionell, pünktlich und luxuriös.",
      reserveRide: "Jetzt Reservieren",
      viewFleet: "Flotte Ansehen",
    },
    services: {
      title: "Unsere Dienstleistungen",
      subtitle: "Luxustransport für jeden Anlass",
      transfer: {
        title: "Premium-Transportservice",
        description: "Professioneller Punkt-zu-Punkt-Chauffeur mit Luxusfahrzeugen",
      },
      corporate: {
        title: "Firmenveranstaltungen",
        description: "Professioneller Service für Meetings, Konferenzen und Firmenveranstaltungen.",
      },
      hourly: {
        title: "Stundenbuchung",
        description: "Flexibler Stundenservice für Shopping, Touren oder mehrere Ziele (mind. 3 Std.).",
      },
      pricing: {
        title: "Transparente Preise",
        basePrice: "Grundpreis",
        perKm: "Pro Kilometer",
        perMinute: "Pro Minute",
      },
      included: {
        title: "Inkludierte Services",
        driver: "Professioneller Chauffeur",
        vehicles: "Premium-Fahrzeuge",
        service247: "24/7 Service",
        wifi: "WiFi an Bord",
      },
      example: {
        label: "Beispiel",
        route: "Brüssel Zentrum → Flughafen",
        calculation: "Berechnung",
      },
    },
    fleet: {
      title: "Unsere Premium-Flotte",
      subtitle: "Makellos gewartete Fahrzeuge",
      onRequest: "Auf Anfrage",
      passengers: "Passagiere",
      features: "Premium-Ausstattung",
      vehicleFeatures: {
        hybrid: "Hybrid",
        climateControl: "Klimaanlage",
        comfortableSeats: "Bequeme Sitze",
        wifi: "WiFi",
        premiumSound: "Premium-Sound",
        extraSpace: "Extra Platz",
      },
      categories: {
        executiveSedan: "Executive Limousine",
        luxurySedan: "Luxus Limousine",
        businessSedan: "Business Limousine",
        luxuryEstate: "Luxus Kombi",
      },
      badges: {
        recommended: "Empfohlen",
        premium: "Premium",
        elegance: "Eleganz",
        maxLuggage: "Max Gepäck",
      },
      luggage: {
        standard: "2 große + 2 kleine Koffer",
        extended: "2 große + 2 kleine Koffer",
      },
    },
    whyUs: {
      title: "Warum Uns Wählen",
      subtitle: "Exzellenz in jedem Detail",
      licensed: {
        title: "Vollständig Lizenziert & Versichert",
        description: "Ihre Sicherheit ist unsere Priorität mit umfassender Deckung",
      },
      chauffeurs: {
        title: "Professionelle Chauffeure",
        description: "Erfahrene, höfliche Fahrer, die sich Ihrem Komfort widmen",
      },
      fleet: {
        title: "Premium-Flotte",
        description: "Makellose Fahrzeuge nach höchsten Standards gewartet",
      },
    },
    
    about: {
      title: "Über Uns",
      subtitle: "Ihr vertrauenswürdiger Partner für Luxustransport",
      experience: {
        title: "Jahre der Exzellenz",
        description: "Mit über 10 Jahren Erfahrung in Premium-Chauffeurservice haben wir uns als Referenz im Luxustransport in Belgien etabliert. Unsere Expertise ermöglicht es uns, Ihre Bedürfnisse zu antizipieren und bei jeder Fahrt tadellosen Service zu bieten.",
      },
      commitment: {
        title: "Unser Engagement",
        description: "Wir verpflichten uns, außergewöhnlichen Service zu bieten, der Ihre Erwartungen übertrifft. Jedes Detail wird sorgfältig berücksichtigt, von der Fahrzeugauswahl bis zur Routenplanung, um Ihre vollständige Zufriedenheit zu gewährleisten.",
      },
      values: {
        title: "Unsere Werte",
        description: "Professionalität, Pünktlichkeit, Diskretion und Exzellenz stehen im Mittelpunkt von allem, was wir tun. Wir behandeln jeden Kunden mit Respekt und Aufmerksamkeit und sorgen für ein personalisiertes Erlebnis, das auf Ihre spezifischen Bedürfnisse zugeschnitten ist.",
      },
      team: {
        title: "Unser Team",
        description: "Unsere erfahrenen und mehrsprachigen Chauffeure werden sorgfältig ausgewählt und regelmäßig geschult. Sie kennen die Region perfekt und sind darauf bedacht, jede Reise angenehm, sicher und komfortabel zu gestalten.",
      },
    },
    booking: {
      title: "Buchen Sie Ihre Luxusfahrt",
      subtitle: "Premium Punkt-zu-Punkt Transportservice",
      detailsTitle: "Buchungsdetails",
      detailsSubtitle: "Füllen Sie Ihre Informationen für ein sofortiges Angebot aus",
      yourInfo: "Ihre Informationen",
      fullName: "Vollständiger Name",
      fullNamePlaceholder: "Max Mustermann",
      email: "E-Mail",
      emailPlaceholder: "max@example.com",
      phone: "Telefon",
      phonePlaceholder: "+32 470 12 34 56",
      serviceType: "Service-Typ",
      serviceTypePlaceholder: "Wählen Sie einen Service",
      serviceDescriptions: {
        transfer: "Punkt-zu-Punkt mit Entfernung + Zeit Berechnung",
        corporate: "Firmenevents - stundenweise abgerechnet",
        hourly: "Flexibler Service - mindestens 3 Stunden",
      },
      vehicle: "Fahrzeug",
      vehiclePlaceholder: "Wählen Sie ein Fahrzeug",
      date: "Datum",
      datePlaceholder: "Wählen Sie ein Datum",
      time: "Uhrzeit",
      timePlaceholder: "HH:MM",
      pickup: "Abholort",
      pickupPlaceholder: "Abholadresse eingeben",
      dropoff: "Zielort",
      dropoffPlaceholder: "Zieladresse eingeben",
      hours: "Anzahl Stunden",
      hoursPlaceholder: "Mindestens 3 Stunden",
      calculating: "Berechnen...",
      calculate: "Preis Berechnen",
      estimatedPrice: "Geschätzter Preis",
      distance: "Entfernung",
      duration: "Dauer",
      confirmBooking: "Buchung Bestätigen",
      processing: "Verarbeitung...",
      errors: {
        fillRequired: "Bitte füllen Sie alle Pflichtfelder aus",
        enterAddresses: "Bitte geben Sie Adressen und Entfernung/Dauer ein",
        enterAddressHours: "Bitte geben Sie Adresse und Stundenanzahl ein",
        calculationError: "Fehler bei der Preisberechnung. Bitte versuchen Sie es erneut.",
      },
      success: {
        title: "Buchung Bestätigt! Referenz: {reference}",
        emailSent: "Eine Bestätigungs-E-Mail wurde an {email} gesendet",
      },
    },
    footer: {
      services: "Dienstleistungen",
      company: "Unternehmen",
      about: "Über Uns",
      fleet: "Flotte",
      tagline: "Premium-Chauffeurservice für anspruchsvolle Kunden",
      quickLinks: "Schnelllinks",
      contact: "Kontakt",
      available247: "24/7 Verfügbar",
      copyright: "© 2025 Luxury Transfer Service. Alle Rechte vorbehalten.",
    },
  },
  
  es: {
    header: {
      services: "Servicios",
      fleet: "Flota",
      about: "Acerca",
      bookNow: "Reservar",
    },
    hero: {
      title: "Experimente",
      titleHighlight: "Transporte Premium",
      subtitle: "Llegue con estilo con nuestro servicio de chófer ejecutivo. Profesional, puntual y lujoso.",
      reserveRide: "Reserve Ahora",
      viewFleet: "Ver Flota",
    },
    services: {
      title: "Nuestros Servicios",
      subtitle: "Transporte de lujo para cada ocasión",
      transfer: {
        title: "Servicio de Transporte Premium",
        description: "Chofer profesional punto a punto con vehículos de lujo",
      },
      corporate: {
        title: "Eventos Corporativos",
        description: "Servicio profesional para reuniones, conferencias y eventos corporativos.",
      },
      hourly: {
        title: "Reserva por Hora",
        description: "Servicio flexible por hora para compras, tours o múltiples destinos (mín. 3h).",
      },
      pricing: {
        title: "Precios Transparentes",
        basePrice: "Precio base",
        perKm: "Por kilómetro",
        perMinute: "Por minuto",
      },
      included: {
        title: "Servicios Incluidos",
        driver: "Chofer profesional",
        vehicles: "Vehículos premium",
        service247: "Servicio 24/7",
        wifi: "WiFi a bordo",
      },
      example: {
        label: "Ejemplo",
        route: "Bruselas Centro → Aeropuerto",
        calculation: "Cálculo",
      },
    },
    fleet: {
      title: "Nuestra Flota Premium",
      subtitle: "Vehículos impecablemente mantenidos",
      onRequest: "Bajo petición",
      passengers: "Pasajeros",
      features: "Características Premium",
      vehicleFeatures: {
        hybrid: "Híbrido",
        climateControl: "Control de clima",
        comfortableSeats: "Asientos confortables",
        wifi: "WiFi",
        premiumSound: "Sonido premium",
        extraSpace: "Espacio extra",
      },
      categories: {
        executiveSedan: "Sedán Ejecutivo",
        luxurySedan: "Sedán de Lujo",
        businessSedan: "Sedán Business",
        luxuryEstate: "Familiar de Lujo",
      },
      badges: {
        recommended: "Recomendado",
        premium: "Premium",
        elegance: "Elegancia",
        maxLuggage: "Máx Equipaje",
      },
      luggage: {
        standard: "2 grandes + 2 pequeñas maletas",
        extended: "2 grandes + 2 pequeñas maletas",
      },
    },
    whyUs: {
      title: "Por Qué Elegirnos",
      subtitle: "Excelencia en cada detalle",
      licensed: {
        title: "Totalmente Licenciado y Asegurado",
        description: "Su seguridad es nuestra prioridad con cobertura integral",
      },
      chauffeurs: {
        title: "Choferes Profesionales",
        description: "Conductores experimentados y corteses dedicados a su comodidad",
      },
      fleet: {
        title: "Flota Premium",
        description: "Vehículos impecables mantenidos según los más altos estándares",
      },
    },
    
    about: {
      title: "Sobre Nosotros",
      subtitle: "Su socio de confianza para transporte de lujo",
      experience: {
        title: "Años de Excelencia",
        description: "Con más de 10 años de experiencia en servicios de chofer premium, nos hemos establecido como la referencia en transporte de lujo en Bélgica. Nuestra experiencia nos permite anticipar sus necesidades y proporcionar un servicio impecable en cada viaje.",
      },
      commitment: {
        title: "Nuestro Compromiso",
        description: "Nos comprometemos a proporcionar un servicio excepcional que supere sus expectativas. Cada detalle es cuidadosamente considerado, desde la selección del vehículo hasta la planificación de la ruta, para garantizar su completa satisfacción.",
      },
      values: {
        title: "Nuestros Valores",
        description: "Profesionalismo, puntualidad, discreción y excelencia están en el corazón de todo lo que hacemos. Tratamos a cada cliente con respeto y atención, asegurando una experiencia personalizada adaptada a sus necesidades específicas.",
      },
      team: {
        title: "Nuestro Equipo",
        description: "Nuestros choferes experimentados y multilingües son cuidadosamente seleccionados y entrenados regularmente. Conocen perfectamente la región y están dedicados a hacer cada viaje agradable, seguro y cómodo.",
      },
    },
    booking: {
      title: "Reserve Su Viaje de Lujo",
      subtitle: "Servicio de transporte premium punto a punto",
      detailsTitle: "Detalles de la Reserva",
      detailsSubtitle: "Complete su información para una cotización instantánea",
      yourInfo: "Su Información",
      fullName: "Nombre Completo",
      fullNamePlaceholder: "Juan Pérez",
      email: "Correo Electrónico",
      emailPlaceholder: "juan@example.com",
      phone: "Teléfono",
      phonePlaceholder: "+32 470 12 34 56",
      serviceType: "Tipo de Servicio",
      serviceTypePlaceholder: "Elija un servicio",
      serviceDescriptions: {
        transfer: "Punto a punto con cálculo de distancia + tiempo",
        corporate: "Eventos corporativos - facturado por hora",
        hourly: "Servicio flexible - mínimo 3 horas",
      },
      vehicle: "Vehículo",
      vehiclePlaceholder: "Seleccione un vehículo",
      date: "Fecha",
      datePlaceholder: "Seleccione una fecha",
      time: "Hora",
      timePlaceholder: "HH:MM",
      pickup: "Lugar de Recogida",
      pickupPlaceholder: "Ingrese dirección de recogida",
      dropoff: "Lugar de Entrega",
      dropoffPlaceholder: "Ingrese dirección de entrega",
      hours: "Número de Horas",
      hoursPlaceholder: "Mínimo 3 horas",
      calculating: "Calculando...",
      calculate: "Calcular Precio",
      estimatedPrice: "Precio Estimado",
      distance: "Distancia",
      duration: "Duración",
      confirmBooking: "Confirmar Reserva",
      processing: "Procesando...",
      errors: {
        fillRequired: "Por favor complete todos los campos obligatorios",
        enterAddresses: "Por favor ingrese direcciones y distancia/duración",
        enterAddressHours: "Por favor ingrese dirección y número de horas",
        calculationError: "Error al calcular el precio. Por favor intente de nuevo.",
      },
      success: {
        title: "¡Reserva Confirmada! Referencia: {reference}",
        emailSent: "Se ha enviado un correo de confirmación a {email}",
      },
    },
    footer: {
      tagline: "Servicio de chofer premium para clientes exigentes",
      quickLinks: "Enlaces Rápidos",
      contact: "Contacto",
      available247: "Disponible 24/7",
      copyright: "© 2025 Luxury Transfer Service. Todos los derechos reservados.",
    },
  },

  
  // Russian translations
  ru: {
    header: {
      services: "Услуги",
      fleet: "Автопарк",
      about: "О нас",
      bookNow: "Забронировать",
    },
    hero: {
      title: "Испытайте",
      titleHighlight: "Премиум Транспорт",
      subtitle: "Прибывайте в стиле с нашей услугой личного водителя. Профессионально, пунктуально и роскошно.",
      reserveRide: "Забронировать поездку",
      viewFleet: "Смотреть автопарк",
    },
    services: {
      title: "Наши услуги",
      subtitle: "Роскошный транспорт для любого случая",
      transfer: {
        title: "Премиум транспортный сервис",
        description: "Профессиональный водитель из точки в точку на роскошных автомобилях",
      },
      corporate: {
        title: "Корпоративные мероприятия",
        description: "Профессиональный сервис для встреч, конференций и корпоративных мероприятий.",
      },
      hourly: {
        title: "Почасовая аренда",
        description: "Гибкий почасовой сервис для шоппинга, экскурсий или нескольких направлений (мин. 3 часа).",
      },
    },
    fleet: {
      title: "Наш автопарк",
      subtitle: "Роскошные автомобили для любого случая",
      passengers: "Пассажиров",
      luggage: "Багаж",
      selectVehicle: "Выбрать автомобиль",
      vehicleFeatures: {
        hybrid: "Гибрид",
        climateControl: "Климат-контроль",
        comfortableSeats: "Комфортные сиденья",
        wifi: "WiFi",
        premiumSound: "Премиум звук",
        extraSpace: "Дополнительное пространство",
      },
      categories: {
        executiveSedan: "Представительский Седан",
        luxurySedan: "Люкс Седан",
        businessSedan: "Бизнес Седан",
        luxuryEstate: "Люкс Универсал",
      },
      badges: {
        recommended: "Рекомендуем",
        premium: "Премиум",
        elegance: "Элегантность",
        maxLuggage: "Макс Багаж",
      },
      luggage: {
        standard: "2 больших + 2 малых чемодана",
        extended: "2 больших + 2 малых чемодана",
      },
    },
    about: {
      title: "О Luxury Transfer Service",
      subtitle: "Ваш партнер в премиум транспорте",
      intro: "С многолетним опытом в индустрии роскошного транспорта, мы гордимся предоставлением исключительного сервиса нашим клиентам по всей Бельгии.",
      experience: {
        title: "Опыт и профессионализм",
        description: "Наши профессиональные водители обучены предоставлять высочайший уровень сервиса, обеспечивая комфортную и безопасную поездку.",
      },
      fleet: {
        title: "Роскошный автопарк",
        description: "Мы поддерживаем парк премиальных автомобилей, включая Lexus ES300h, Mercedes E-Class и BMW Série 5, все в безупречном состоянии.",
      },
      commitment: {
        title: "Наши обязательства",
        description: "Мы стремимся к пунктуальности, профессионализму и удовлетворенности клиентов. Ваш комфорт и безопасность - наши главные приоритеты.",
      },
    },
    booking: {
      title: "Забронировать поездку",
      selectService: "Выберите услугу",
      selectVehicle: "Выберите автомобиль",
      tripDetails: "Детали поездки",
      contactInfo: "Контактная информация",
      airportTransfer: "Трансфер из аэропорта",
      corporateEvent: "Корпоративное мероприятие",
      hourlyService: "Почасовой сервис",
      pickupLocation: "Место посадки",
      dropoffLocation: "Место высадки",
      date: "Дата",
      time: "Время",
      hours: "Часы (мин. 3)",
      name: "Полное имя",
      email: "Email",
      phone: "Телефон",
      calculatePrice: "Рассчитать цену",
      estimatedPrice: "Ориентировочная цена",
      bookNow: "Забронировать сейчас",
      calculating: "Расчет...",
      required: "обязательно",
      pickupPlaceholder: "Введите адрес посадки",
      dropoffPlaceholder: "Введите адрес высадки",
    },
    confirmation: {
      title: "Бронирование подтверждено!",
      message: "Спасибо за бронирование. Мы отправили подтверждение на ваш email.",
      reference: "Номер бронирования",
      backHome: "Вернуться на главную",
    },
    footer: {
      tagline: "Премиум сервис водителя для взыскательных клиентов",
      quickLinks: "Быстрые ссылки",
      contact: "Контакты",
      available247: "Доступно 24/7",
      copyright: "© 2025 Luxury Transfer Service. Все права защищены.",
    },
  },

  // Arabic translations
  ar: {
    header: {
      services: "الخدمات",
      fleet: "الأسطول",
      about: "من نحن",
      bookNow: "احجز الآن",
    },
    hero: {
      title: "استمتع بتجربة",
      titleHighlight: "النقل المتميز",
      subtitle: "اصل بأناقة مع خدمة السائق التنفيذي. احترافي، دقيق وفاخر.",
      reserveRide: "احجز رحلتك",
      viewFleet: "عرض الأسطول",
    },
    services: {
      title: "خدماتنا",
      subtitle: "نقل فاخر لكل مناسبة",
      transfer: {
        title: "خدمة النقل المتميزة",
        description: "سائق محترف من نقطة إلى نقطة مع سيارات فاخرة",
      },
      corporate: {
        title: "الفعاليات الشركات",
        description: "خدمة احترافية للاجتماعات والمؤتمرات والفعاليات الشركات.",
      },
      hourly: {
        title: "الحجز بالساعة",
        description: "خدمة مرنة بالساعة للتسوق أو الجولات أو وجهات متعددة (الحد الأدنى 3 ساعات).",
      },
    },
    fleet: {
      title: "أسطولنا",
      subtitle: "سيارات فاخرة لكل مناسبة",
      passengers: "الركاب",
      luggage: "الأمتعة",
      selectVehicle: "اختر السيارة",
      vehicleFeatures: {
        hybrid: "هجين",
        climateControl: "تكييف",
        comfortableSeats: "مقاعد مريحة",
        wifi: "واي فاي",
        premiumSound: "صوت متميز",
        extraSpace: "مساحة إضافية",
      },
      categories: {
        executiveSedan: "سيدان تنفيذي",
        luxurySedan: "سيدان فاخر",
        businessSedan: "سيدان أعمال",
        luxuryEstate: "عربة فاخرة",
      },
      badges: {
        recommended: "موصى به",
        premium: "بريميوم",
        elegance: "أناقة",
        maxLuggage: "حد أقصى للأمتعة",
      },
      luggage: {
        standard: "2 حقيبة كبيرة + 2 حقيبة صغيرة",
        extended: "2 حقائب كبيرة + 2 حقائب صغيرة",
      },
    },
    about: {
      title: "عن Luxury Transfer Service",
      subtitle: "شريكك في النقل المتميز",
      intro: "مع سنوات من الخبرة في صناعة النقل الفاخر، نفخر بتقديم خدمة استثنائية لعملائنا في جميع أنحاء بلجيكا.",
      experience: {
        title: "الخبرة والاحترافية",
        description: "سائقونا المحترفون مدربون على تقديم أعلى مستوى من الخدمة، مما يضمن رحلة مريحة وآمنة.",
      },
      fleet: {
        title: "أسطول فاخر",
        description: "نحافظ على أسطول من السيارات المتميزة، بما في ذلك Lexus ES300h و Mercedes E-Class و BMW Série 5، جميعها في حالة ممتازة.",
      },
      commitment: {
        title: "التزامنا",
        description: "نحن ملتزمون بالدقة والاحترافية ورضا العملاء. راحتك وسلامتك هي أولوياتنا القصوى.",
      },
    },
    booking: {
      title: "احجز رحلتك",
      selectService: "اختر الخدمة",
      selectVehicle: "اختر السيارة",
      tripDetails: "تفاصيل الرحلة",
      contactInfo: "معلومات الاتصال",
      airportTransfer: "نقل المطار",
      corporateEvent: "فعالية شركات",
      hourlyService: "خدمة بالساعة",
      pickupLocation: "موقع الصعود",
      dropoffLocation: "موقع النزول",
      date: "التاريخ",
      time: "الوقت",
      hours: "الساعات (الحد الأدنى 3)",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      calculatePrice: "احسب السعر",
      estimatedPrice: "السعر التقديري",
      bookNow: "احجز الآن",
      calculating: "جاري الحساب...",
      required: "مطلوب",
      pickupPlaceholder: "أدخل عنوان الصعود",
      dropoffPlaceholder: "أدخل عنوان النزول",
    },
    confirmation: {
      title: "تم تأكيد الحجز!",
      message: "شكراً لحجزك. لقد أرسلنا تأكيداً إلى بريدك الإلكتروني.",
      reference: "رقم الحجز",
      backHome: "العودة للرئيسية",
    },
    footer: {
      tagline: "خدمة سائق متميزة للعملاء المميزين",
      quickLinks: "روابط سريعة",
      contact: "اتصل بنا",
      available247: "متاح 24/7",
      copyright: "© 2025 Luxury Transfer Service. جميع الحقوق محفوظة.",
    },
  },

  // Chinese translations
  zh: {
    header: {
      services: "服务",
      fleet: "车队",
      about: "关于我们",
      bookNow: "立即预订",
    },
    hero: {
      title: "体验",
      titleHighlight: "高端交通服务",
      subtitle: "享受我们专业司机服务的优雅出行。专业、准时、奢华。",
      reserveRide: "预订行程",
      viewFleet: "查看车队",
    },
    services: {
      title: "我们的服务",
      subtitle: "为各种场合提供豪华交通",
      transfer: {
        title: "高端交通服务",
        description: "专业点对点司机服务，配备豪华车辆",
      },
      corporate: {
        title: "企业活动",
        description: "为会议、研讨会和企业活动提供专业服务。",
      },
      hourly: {
        title: "按小时预订",
        description: "灵活的小时制服务，适合购物、观光或多个目的地（最少3小时）。",
      },
    },
    fleet: {
      title: "我们的车队",
      subtitle: "适合各种场合的豪华车辆",
      passengers: "乘客",
      luggage: "行李",
      selectVehicle: "选择车辆",
      vehicleFeatures: {
        hybrid: "混合动力",
        climateControl: "空调",
        comfortableSeats: "舒适座椅",
        wifi: "WiFi",
        premiumSound: "高级音响",
        extraSpace: "额外空间",
      },
      categories: {
        executiveSedan: "行政轿车",
        luxurySedan: "豪华轿车",
        businessSedan: "商务轿车",
        luxuryEstate: "豪华旅行车",
      },
      badges: {
        recommended: "推荐",
        premium: "高级",
        elegance: "优雅",
        maxLuggage: "最大行李",
      },
      luggage: {
        standard: "2个大行李 + 2个小行李",
        extended: "2个大行李 + 2个小行李",
      },
    },
    about: {
      title: "关于 Luxury Transfer Service",
      subtitle: "您的高端交通合作伙伴",
      intro: "凭借多年豪华交通行业经验，我们为比利时各地的客户提供卓越服务而自豪。",
      experience: {
        title: "经验与专业",
        description: "我们的专业司机经过培训，提供最高水平的服务，确保舒适安全的旅程。",
      },
      fleet: {
        title: "豪华车队",
        description: "我们维护着一支高端车队，包括 Lexus ES300h、Mercedes E-Class 和 BMW Série 5，所有车辆均保持完美状态。",
      },
      commitment: {
        title: "我们的承诺",
        description: "我们致力于准时、专业和客户满意。您的舒适和安全是我们的首要任务。",
      },
    },
    booking: {
      title: "预订行程",
      selectService: "选择服务",
      selectVehicle: "选择车辆",
      tripDetails: "行程详情",
      contactInfo: "联系信息",
      airportTransfer: "机场接送",
      corporateEvent: "企业活动",
      hourlyService: "按小时服务",
      pickupLocation: "上车地点",
      dropoffLocation: "下车地点",
      date: "日期",
      time: "时间",
      hours: "小时数（最少3小时）",
      name: "全名",
      email: "电子邮件",
      phone: "电话",
      calculatePrice: "计算价格",
      estimatedPrice: "预估价格",
      bookNow: "立即预订",
      calculating: "计算中...",
      required: "必填",
      pickupPlaceholder: "输入上车地址",
      dropoffPlaceholder: "输入下车地址",
    },
    confirmation: {
      title: "预订已确认！",
      message: "感谢您的预订。我们已将确认信息发送到您的邮箱。",
      reference: "预订编号",
      backHome: "返回首页",
    },
    footer: {
      tagline: "为尊贵客户提供高端司机服务",
      quickLinks: "快速链接",
      contact: "联系我们",
      available247: "全天候服务",
      copyright: "© 2025 Luxury Transfer Service. 保留所有权利。",
    },
  },

  // Italian translations
  it: {
    header: {
      services: "Servizi",
      fleet: "Flotta",
      about: "Chi Siamo",
      bookNow: "Prenota Ora",
    },
    hero: {
      title: "Scopri",
      titleHighlight: "Il Trasporto Premium",
      subtitle: "Arriva con stile con il nostro servizio di autista executive. Professionale, puntuale e lussuoso.",
      reserveRide: "Prenota il Tuo Viaggio",
      viewFleet: "Vedi la Flotta",
    },
    services: {
      title: "I Nostri Servizi",
      subtitle: "Trasporto di lusso per ogni occasione",
      transfer: {
        title: "Servizio di Trasporto Premium",
        description: "Autista professionale punto a punto con veicoli di lusso",
      },
      corporate: {
        title: "Eventi Aziendali",
        description: "Servizio professionale per riunioni, conferenze ed eventi aziendali.",
      },
      hourly: {
        title: "Prenotazione Oraria",
        description: "Servizio orario flessibile per shopping, tour o destinazioni multiple (min. 3 ore).",
      },
    },
    fleet: {
      title: "La Nostra Flotta",
      subtitle: "Veicoli di lusso per ogni occasione",
      passengers: "Passeggeri",
      luggage: "Bagagli",
      selectVehicle: "Seleziona Veicolo",
      vehicleFeatures: {
        hybrid: "Ibrido",
        climateControl: "Climatizzatore",
        comfortableSeats: "Sedili confortevoli",
        wifi: "WiFi",
        premiumSound: "Audio premium",
        extraSpace: "Spazio extra",
      },
      categories: {
        executiveSedan: "Berlina Executive",
        luxurySedan: "Berlina di Lusso",
        businessSedan: "Berlina Business",
        luxuryEstate: "Station Wagon di Lusso",
      },
      badges: {
        recommended: "Consigliato",
        premium: "Premium",
        elegance: "Eleganza",
        maxLuggage: "Max Bagagli",
      },
      luggage: {
        standard: "2 grandi + 2 piccole valigie",
        extended: "2 grandi + 2 piccole valigie",
      },
    },
    about: {
      title: "Su Luxury Transfer Service",
      subtitle: "Il tuo partner nel trasporto premium",
      intro: "Con anni di esperienza nell'industria del trasporto di lusso, siamo orgogliosi di fornire un servizio eccezionale ai nostri clienti in tutto il Belgio.",
      experience: {
        title: "Esperienza e Professionalità",
        description: "I nostri autisti professionisti sono formati per fornire il massimo livello di servizio, garantendo un viaggio confortevole e sicuro.",
      },
      fleet: {
        title: "Flotta di Lusso",
        description: "Manteniamo una flotta di veicoli premium, tra cui Lexus ES300h, Mercedes E-Class e BMW Série 5, tutti in perfette condizioni.",
      },
      commitment: {
        title: "Il Nostro Impegno",
        description: "Siamo impegnati nella puntualità, professionalità e soddisfazione del cliente. Il tuo comfort e la tua sicurezza sono le nostre massime priorità.",
      },
    },
    booking: {
      title: "Prenota il Tuo Viaggio",
      selectService: "Seleziona Servizio",
      selectVehicle: "Seleziona Veicolo",
      tripDetails: "Dettagli del Viaggio",
      contactInfo: "Informazioni di Contatto",
      airportTransfer: "Trasferimento Aeroporto",
      corporateEvent: "Evento Aziendale",
      hourlyService: "Servizio Orario",
      pickupLocation: "Luogo di Ritiro",
      dropoffLocation: "Luogo di Consegna",
      date: "Data",
      time: "Ora",
      hours: "Ore (min. 3)",
      name: "Nome Completo",
      email: "Email",
      phone: "Telefono",
      calculatePrice: "Calcola Prezzo",
      estimatedPrice: "Prezzo Stimato",
      bookNow: "Prenota Ora",
      calculating: "Calcolo...",
      required: "obbligatorio",
      pickupPlaceholder: "Inserisci indirizzo di ritiro",
      dropoffPlaceholder: "Inserisci indirizzo di consegna",
    },
    confirmation: {
      title: "Prenotazione Confermata!",
      message: "Grazie per la tua prenotazione. Abbiamo inviato una conferma alla tua email.",
      reference: "Numero di Prenotazione",
      backHome: "Torna alla Home",
    },
    footer: {
      tagline: "Servizio di autista premium per clienti esigenti",
      quickLinks: "Link Rapidi",
      contact: "Contatti",
      available247: "Disponibile 24/7",
      copyright: "© 2025 Luxury Transfer Service. Tutti i diritti riservati.",
    },
  },

};

export const languageNames = {
  en: "English",
  fr: "Français",
  nl: "Nederlands",
  de: "Deutsch",
  es: "Español",
  ru: "Русский",
  ar: "العربية",
  zh: "中文",
  it: "Italiano",
};

export const languageFlags = {
  en: "🇬🇧",
  fr: "🇫🇷",
  nl: "🇳🇱",
  de: "🇩🇪",
  es: "🇪🇸",
  ru: "🇷🇺",
  ar: "🇸🇦",
  zh: "🇨🇳",
  it: "🇮🇹",
};
